export enum RequestOperationType {
  ADD_ENTITLEMENT_TO_USER = 1,
  REMOVE_ENTITLEMENT_FROM_USER = 2,
  ADD_ENTITLEMENT_TO_CATALOG = 3,
  REMOVE_ENTITLEMENT_FROM_CATALOG = 4,
  ADD_EMERGENCY_USER_RACF = 5,
  ADD_BUSINESS_ROLE_TO_USER = 6,
  REMOVE_BUSINESS_ROLE_TO_USER = 7,
  RESET_PASSWORD = 8,
  CHANGE_PASSWORD = 9,
  DELETE_BUSINESS_ROLE = 10,
  CREATE_BUSINESS_ROLE = 11,
  UPDATE_BUSINESS_ROLE = 12,
  SERVICE_REQUEST = 13,
  REPORT_GENERETING = 14,
  ADD_TEMPORARY_ENTITLEMENT = 15,
  ADD_ENTITLEMENT_TO_TECHNICAL_USER = 18,
  REMOVE_ENTITLEMENT_FROM_TECHNICAL_USER = 19,
  DELETE_TECHNICAL_USER = 20,
  TECHNICAL_USER_RESET_PWD = 21,
  TECHNICAL_USER_CHANGE_PWD = 22,
  CREATE_TECH_USER = 23,
}

export const REQUEST_TYPE_LIST = [
  {
    label: "ADD_ENTITLEMENT_TO_USER",
    value: 1,
  },
  {
    label: "REMOVE_ENTITLEMENT_FROM_USER",
    value: 2,
  },
  {
    label: "ADD_ENTITLEMENT_TO_CATALOG",
    value: 3,
  },
  {
    label: "REMOVE_ENTITLEMENT_FROM_CATALOG",
    value: 4,
  },
  {
    label: "ADD_EMERGENCY_USER_RACF",
    value: 5,
  },
  {
    label: "ADD_BUSINESS_ROLE_TO_USER",
    value: 6,
  },
  {
    label: "REMOVE_BUSINESS_ROLE_TO_USER",
    value: 7,
  },
  {
    label: "RESET_PASSWORD",
    value: 8,
  },
  {
    label: "CHANGE_PASSWORD",
    value: 9,
  },
  {
    label: "DELETE_BUSINESS_ROLE",
    value: 10,
  },
  {
    label: "CREATE_BUSINESS_ROLE",
    value: 11,
  },
  {
    label: "UPDATE_BUSINESS_ROLE",
    value: 12,
  },
  {
    label: "SERVICE_REQUEST",
    value: 13,
  },
  {
    label: "REPORT_GENERETING",
    value: 14,
  },
  {
    label: "ADD_TEMPORARY_ENTITLEMENT",
    value: 15,
  },
  {
    label: "ADD_ENTITLEMENT_TO_TECHNICAL_USER",
    value: 18,
  },
  {
    label: "REMOVE_ENTITLEMENT_FROM_TECHNICAL_USER",
    value: 19,
  },
  {
    label: "DELETE_TECHNICAL_USER",
    value: 20,
  },
  {
    label: "TECHNICAL_USER_RESET_PWD",
    value: 21,
  },
  {
    label: "TECHNICAL_USER_CHANGE_PWD",
    value: 22,
  },
  {
    label: "CREATE_TECH_USER",
    value: 23,
  },
];
